import { useEffect } from "react";

//Custom Hook para actualizar las variables en el CSS de App.css, con los colores de la nueva paleta alternativa.
const useThemeStylingByHEX = (colorSelected) => {
  const actualizarRootStyles = () => {
    //Actualizar las variables del :root y sustituirlos por los del nuevo Tema.

    document.documentElement.style.setProperty('--color-by-company', colorSelected.bg);
    document.documentElement.style.setProperty('--color-degraded-by-company', colorSelected.bg_degraded);

  };

  useEffect(() => {
    actualizarRootStyles();
  }, [colorSelected]);
};

export default useThemeStylingByHEX;
